import { render } from "./ProposalsTableComponent.vue?vue&type=template&id=0ef018aa&scoped=true"
import script from "./ProposalsTableComponent.vue?vue&type=script&lang=js"
export * from "./ProposalsTableComponent.vue?vue&type=script&lang=js"

import "./ProposalsTableComponent.vue?vue&type=style&index=0&id=0ef018aa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef018aa"]])

export default __exports__